<template>
  <div :class="_class">
    <t-spinner :initial="initial"/>
  </div>
</template>

<script>
import TSpinner from './TSpinner'
export default {
  name: 't-loading',
  props: ['visible', 'initial'],
  components: { TSpinner },
  computed: {
    _class () {
      return `loading ${this.visible ? 'visible' : ''}`
    }
  },
  watch: {
    visible (val) {
      if (!this.initial) {
        const element = document.documentElement
        if (val) {
          const scrollBarWidth = window.innerWidth - element.clientWidth
          element.style.overflowY = 'hidden'
          element.style.paddingRight = `${scrollBarWidth}px`
        } else {
          element.style.overflowY = 'auto'
          element.style.paddingRight = '0px'
        }
      }
    }
  },
  mounted () {
    document.documentElement.appendChild(this.$el)
  },
  beforeDestroy () {
    document.documentElement.removeChild(this.$el)
  }
}
</script>

<style lang="scss" scoped>
.loading {
  background-color: var(--scrim);
  transition: opacity 200ms cubic-bezier(0.4, 0, 1, 1);
  opacity: 0;
  height: 100vh;
  position: fixed;
  z-index: 30;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  &.visible {
    opacity: 1;
    transition: opacity 250ms cubic-bezier(0, 0, .2, 1);
    pointer-events: all;
  }
}
</style>
